// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetAllCustomFieldValuesQueryVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
}>;

export type GetAllCustomFieldValuesQuery = {
  customFieldDefinition: {
    values?: Array<{
      value?: string | null;
      label?: string | null;
      code?: string | null;
      referenceId?: string | null;
    } | null> | null;
  };
};

export const GetAllCustomFieldValuesDocument = gql`
    query GetAllCustomFieldValues($uid: String!) {
  customFieldDefinition(uid: $uid) {
    values {
      value
      label
      code
      referenceId
    }
  }
}
    ` as unknown as DocumentNode<GetAllCustomFieldValuesQuery, GetAllCustomFieldValuesQueryVariables>;
